export type LocaleValue =
  | 'de-DE'
  | 'fr-FR'
  | 'es-ES'
  | 'it-IT'
  | 'nl-NL'
  | 'en';

export type LanguageCode = 'de' | 'fr' | 'es' | 'it' | 'nl' | 'en' | 'tu';

export type MarketCode = 'DE' | 'FR' | 'ES' | 'IT' | 'NL';
export const ALLOWED_MARKETS = ['DE', 'FR', 'ES', 'IT', 'NL'];
